import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { countryIs, field, REQUIRED, OPTIONAL } from "./utils";
import * as ESTONIA from "pages/employer-of-record/onboarding/profile-info/form/ee/constants.ee";
import { NATIONALITIES } from "pages/employer-of-record/onboarding/profile-info/constants";
import { taxIdFieldConfig, confirmTaxIdFieldConfig } from "./_common";

export const estoniaFields = {
  eeGender: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "eeGender",
    label: "Gender",
    placeholder: "Select Gender",
    options: ESTONIA.GENDER_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => "",
  }),
  eeBirthCountry: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "eeBirthCountry",
    label: "Place of Birth (Country)",
    placeholder: "Select country",
    options: NATIONALITIES,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => "",
  }),
  eeBirthCity: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "eeBirthCity",
    label: "Place of Birth (City)",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => "",
  }),
  eeMaritalStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "eeMaritalStatus",
    label: "Marital Status",
    placeholder: "Select marital status",
    options: ESTONIA.MARITAL_STATUS_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => "",
  }),
  eeHasDisability: field({
    type: FieldTypes.checkbox,
    informationType: "identification",
    name: "eeHasDisability",
    label: "Do you have a registered disability?",
    description: "Indicate if you have a registered disability",
    validations: OPTIONAL,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => false,
  }),
  eeEducationLevel: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "eeEducationLevel",
    label: "Highest level of formal education completed",
    placeholder: "Select Education Level",
    options: ESTONIA.EDUCATION_LEVEL_OPTIONS,
    validations: OPTIONAL,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => "",
  }),
  eeAcademicDegree: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "eeAcademicDegree",
    label: "Academic or scientific degree held (if applicable)",
    validations: OPTIONAL,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => "",
  }),
  eeFieldOfStudy: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "eeFieldOfStudy",
    label: "Field of study for the highest degree completed",
    validations: OPTIONAL,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => "",
  }),
  eePassportNumber: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "eePassportNumber",
    label: "Passport Number",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => "",
  }),
  eeIdCardIssueDate: field({
    type: FieldTypes.date,
    informationType: "identification",
    name: "eeIdCardIssueDate",
    label: "ID Card Date of Issue",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => "",
  }),
  eeIdCardIssuer: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "eeIdCardIssuer",
    label: "ID Card Issued by",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("EE"),
    },
    value: () => "",
  }),
  eeIk: taxIdFieldConfig("EE", "eeIk"),
  eeConfirmIk: confirmTaxIdFieldConfig("EE", "eeIk"),
};
